<template>
    <v-container fluid>
        <menu-modifications @seleccion="seleccion"></menu-modifications>
        <ensayos v-if="elegido == 0"></ensayos>
        <h-m-i v-else></h-m-i>
    </v-container>
</template>

<script>
import moment from 'moment-timezone';
import Ensayos from '@/components/Modifications/Ensayos.vue'
import MenuModifications from '@/components/Modifications/MenuModifications.vue'
import HMI from '@/components/Modifications/HMI.vue'

export default {
    components:{
        Ensayos, MenuModifications, HMI
    },
    data() {
        return {
            elegido: 0,
        }
    },
    methods: {
        seleccion(eleccion){
            this.elegido=eleccion;
            switch (eleccion) {}
        },
    },
}
</script>

<style>
    
</style>